// Сума гривень прописом (українською) для комірки Q35 ТТН:
//   1234.5  -> "Одна тисяча двісті тридцять чотири гривні 50 копійок"
//   0       -> "Нуль гривень 00 копійок"
// Копійки завжди цифрами (як у шаблоні).

const ONES_M = [
    '', 'один', 'два', 'три', 'чотири', 'п\'ять', 'шість', 'сім', 'вісім', 'дев\'ять',
    'десять', 'одинадцять', 'дванадцять', 'тринадцять', 'чотирнадцять', 'п\'ятнадцять',
    'шістнадцять', 'сімнадцять', 'вісімнадцять', 'дев\'ятнадцять',
];
const ONES_F = [...ONES_M];
ONES_F[1] = 'одна';
ONES_F[2] = 'дві';

const TENS = [
    '', '', 'двадцять', 'тридцять', 'сорок', 'п\'ятдесят', 'шістдесят',
    'сімдесят', 'вісімдесят', 'дев\'яносто',
];
const HUNDREDS = [
    '', 'сто', 'двісті', 'триста', 'чотириста', 'п\'ятсот', 'шістсот',
    'сімсот', 'вісімсот', 'дев\'ятсот',
];

// [одиниця, дві-чотири, п'ять+]
const THOUSAND_FORMS: [string, string, string] = ['тисяча', 'тисячі', 'тисяч'];
const MILLION_FORMS: [string, string, string] = ['мільйон', 'мільйони', 'мільйонів'];
const HRYVNIA_FORMS: [string, string, string] = ['гривня', 'гривні', 'гривень'];

const plural = (n: number, forms: [string, string, string]): string => {
    const mod100 = n % 100;
    const mod10 = n % 10;
    if (mod100 >= 11 && mod100 <= 14) return forms[2];
    if (mod10 === 1) return forms[0];
    if (mod10 >= 2 && mod10 <= 4) return forms[1];
    return forms[2];
};

const tripletToWords = (n: number, feminine: boolean): string => {
    const words: string[] = [];
    const h = Math.floor(n / 100);
    const rest = n % 100;
    if (h) words.push(HUNDREDS[h]);
    if (rest < 20) {
        if (rest) words.push((feminine ? ONES_F : ONES_M)[rest]);
    } else {
        words.push(TENS[Math.floor(rest / 10)]);
        const one = rest % 10;
        if (one) words.push((feminine ? ONES_F : ONES_M)[one]);
    }
    return words.join(' ');
};

const capitalize = (s: string): string => (s ? s[0].toUpperCase() + s.slice(1) : s);

export const uaHryvniaToWords = (amount: number): string => {
    const safe = Number.isFinite(amount) ? Math.abs(amount) : 0;
    const hryvnias = Math.floor(safe + 1e-9);
    const kopiykas = Math.round((safe - hryvnias) * 100);

    const parts: string[] = [];

    const millions = Math.floor(hryvnias / 1_000_000);
    const thousands = Math.floor((hryvnias % 1_000_000) / 1000);
    const units = hryvnias % 1000;

    if (millions) {
        parts.push(tripletToWords(millions, false));
        parts.push(plural(millions, MILLION_FORMS));
    }
    if (thousands) {
        parts.push(tripletToWords(thousands, true));
        parts.push(plural(thousands, THOUSAND_FORMS));
    }
    if (units || (!millions && !thousands)) {
        // «гривня» — жіночого роду: одна/дві гривні
        parts.push(tripletToWords(units, true) || 'нуль');
    }

    const words = parts.filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
    const kop = String(kopiykas).padStart(2, '0');
    return `${capitalize(words)} ${plural(hryvnias, HRYVNIA_FORMS)} ${kop} копійок`;
};
